// extracted by mini-css-extract-plugin
export var text = "_as-0";